<template>
  <a-table :columns="columns" :dataSource="dataSource" rowKey='id' :loading="isReload"
  :pagination="{defaultPageSize: 10, pageSizeOptions: ['10', '20', '30', '40', '50', '100'], showSizeChanger : true  }" :locale="locale">
      <span slot="status" slot-scope="text, row">
          <a-tag :color="(row.status)?'green':'red'">
              {{(row.status)?'ใช้งานได้':'บล็อค'}}
          </a-tag>
      </span>
      <a-dropdown slot="Action" slot-scope="text, row">
          <a-menu slot="overlay" >
              <a-menu-item key="1" @click="naviageToPaartnerSboEmp(row.id)"> <a-icon type="edit" />จัดการพนักงาน</a-menu-item>
              <a-menu-item key="2" @click="block(row)"> <a-icon type="close" /> {{(!row.status)?'เลิกบล็อค':'บล็อค'}}</a-menu-item>
          </a-menu>
          <a-button style="margin-left: 8px">จัดการ <a-icon type="down" /> </a-button>
      </a-dropdown>
  </a-table>
</template>

<script>
import thTH from 'ant-design-vue/es/locale/th_TH'
export default {
  props: [
    'isReload',
    'dataSource',
    'columns',
  ],
  name: 'TablePartnerSBO',
  data() {
    return {
      locale: thTH,
      thTH,
    }
  },
  methods: {
    naviageToPaartnerSboEmp (id) {
      this.$router.push({ path: `./partnerSBO/${id}` })
    },

    getDetailPartnerSBO(id) {
      this.$emit('edit-submitted', id)
    },
    block(result) {
      this.$emit('block-submitted', result)
    },
  },
}
</script>

<style>

</style>
